import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getPOExceptionMgmtBuyerTable = createApi(`POExceptionMgmtBuyerTableSlice`,"POST");

const POExceptionMgmtBuyerTableSlice = createSlice({
  name: 'POExceptionMgmtBuyerTableSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPOExceptionMgmtBuyerTable.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPOExceptionMgmtBuyerTable.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPOExceptionMgmtBuyerTable.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default POExceptionMgmtBuyerTableSlice.reducer;